import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScHeroCard = styled.div`
  position: relative;
  perspective: 1000px;
  position: relative;

  & .card {
    transition: transform 1s;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    height: 100%;

    &.flipped {
      transform: rotateY(180deg);
    }
  }

  & .front,
  & .back {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    border-radius: 20px;
    background: linear-gradient(350deg, #6700a1 -1.55%, #e3342f 107.46%);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  & .front {
    text-align: center;
    padding-top: 182px;
    display: flex;
    flex-direction: column;
  }

  & .back {
    height: 100%;
    overflow: hidden;
    transform: rotateY(180deg);
    padding: 24px 16px 0;
    display: flex;
    flex-direction: column;
    gap: 24px;

    & > ul {
      flex: 1;
      overflow-y: auto;
      font-size: 12px;
      font-weight: 400;
      line-height: 130%;
      display: grid;
      gap: 24px;
      list-style: none;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 3px;
      }
    }

    & > .terms-btn img {
      transform: rotate(180deg);
    }
  }

  & .hero-img {
    display: block;
    position: absolute;
    left: 0;
    top: -70px;
    object-fit: contain;
    @media (${device.mobile}) {
      width: 332px;
      height: 255px;
    }
  }

  & .text {
    margin-bottom: 11px;
    text-align: center;
    text-transform: uppercase;

    & > .title {
      color: rgba(255, 255, 255, 0.6);
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.16px;
    }

    & > .fs-count {
      font-size: 99px;
      line-height: 100%;
      letter-spacing: 2.97px;

      @media (${device.mobile}) {
        font-size: 90px;
        letter-spacing: 2.7px;
      }
    }

    & > .fs {
      font-size: 32px;
      line-height: 40px;
      letter-spacing: 0.96px;
    }
  }

  & .benefits {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 120px);
    column-gap: 30px;
    text-transform: uppercase;
    margin-bottom: 4px;
    place-content: center;
    flex: 1;

    & > div {
      text-align: center;
      display: grid;
      place-items: center;
      gap: 3px;
    }
  }

  & .terms-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    padding: 12px;
    cursor: pointer;
    text-align: center;
  }
`;
